import { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Pagination from '@components/@core/Pagination';
import ConnectionCard from '@components/ConnectionCard';
import CommunityActions from '~/actions/community';

const ReceivedRequests = ({ user, requests }) => {
    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const total = requests?.length > 0 ? Math.ceil(requests?.length / 20) : 0;
    const limit = (page - 1) * 20;

    const handleConnect = (connection) => () => {
        const payload = {
            data: { payload: { connection_id: connection.id }, action: 'active' },
            after: { type: 'GETCOMMUNITYCONNECTIONS_REQUEST', payload: { user_id: user.id } },
        };
        dispatch(CommunityActions.postconnectionupdateRequest(payload));
    };

    const handleReject = (connection) => () => {
        const payload = {
            data: { payload: { connection_id: connection.id }, action: 'rejected' },
            after: { type: 'GETCOMMUNITYCONNECTIONS_REQUEST', payload: { user_id: user.id } },
        };
        dispatch(CommunityActions.postconnectionupdateRequest(payload));
    };

    const handleOpenDetail = (connect) => () => {
        const { user_id, slug } = connect.connector;
        dispatch(CommunityActions.getcommunityuserRequest({ userId: user_id }, null, `/${slug}/about`));
    };

    return (
        <>
            {requests.length ? (
                <>
                    <Row className="connections-received-request mx-1">
                        {requests.map((connection, index) => {
                            return index > 19 + limit || index < limit ? null : (
                                <Col key={connection.id} className="p-2" xs={12} sm={6} md={3}>
                                    <ConnectionCard data={connection} tab="received" onClick={handleConnect(connection)} onReject={handleReject(connection)} onOpen={handleOpenDetail(connection)} />
                                </Col>
                            );
                        })}
                    </Row>
                    <Pagination total={total} current={page} pers={[]} onChange={(e) => setPage(e)} />
                </>
            ) : (
                <p className="dsl-b16 p-3">No requests</p>
            )}
        </>
    );
};

ReceivedRequests.propTypes = {
    user: PropTypes.shape({ id: PropTypes.number }),
    requests: PropTypes.array,
};

ReceivedRequests.defaultProps = {
    user: { id: 0 },
    requests: [],
};

export default ReceivedRequests;
